import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from '@/types/utils';

export class IIndexRoute {
  id: string | number;
  adet: string;
  @Type(() => Number)
  desi: number;
  pointName: string;
  hidden: number;
  routeid: string | number;
  sessionid: string | number;

  @Type(() => Date)
  createdate: Date;
  lastupdate: Date;
}

export class IIndexRouteResponse {
  @Type(() => IIndexRoute)
  result: IIndexRoute;
}

export class IIndexRouteListResponse extends IPagination {
  @Type(() => IIndexRoute)
  results: IIndexRoute[];
}

export class IIndexRouteQueryDto extends IQueryPaginationDto {
  adet?: string;
  desi?: number;
  pointName?: string;
  hidden?: number;
  routeId?: string;
}
